import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class PlayersCountInput extends Component {
  static propTypes = {
    minPlayers: PropTypes.number.isRequired,
    maxPlayers: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isDisabled: PropTypes.bool,
  }

  static defaultProps = {
    isDisabled: false,
  }

  normalize (value) {
    const { maxPlayers, minPlayers } = this.props

    if (maxPlayers < value) {
      return minPlayers
    } else if (minPlayers > value) {
      return maxPlayers
    }

    return value
  }

  handleChange (event) {
    let value = parseInt(event.target.value) // setState skipped because view should already have last value

    if (!isNaN(value)) {
      value = this.normalize(value)
      this.props.onChange(value)
    } else {
      this.props.onChange(undefined)
      value = ''
    }

    this.setState({ value })
  }

  handlePlus () {
    let value = parseInt(this.props.value)

    if (isNaN(value)) {
      value = this.props.minPlayers
    } else {
      value += 1
    }

    this.props.onChange(this.normalize(value))
  }

  handleMinus () {
    let value = parseInt(this.props.value)

    if (isNaN(value)) {
      value = this.props.maxPlayers
    } else {
      value = value - 1
    }

    this.props.onChange(this.normalize(value))
  }

  render () {
    const { value, minPlayers, maxPlayers } = this.props

    return (
      <div className="players_count_input">
        <button className="minus" onClick={this.handleMinus.bind(this)} aria-label="Minus Player">
          -
        </button>
        <input
          type="number"
          onChange={this.handleChange.bind(this)}
          value={value || ''}
          placeholder="0"
          min={minPlayers}
          max={maxPlayers}
          name="players_count"
          aria-label="Players Count Select"
        />
        <button className="plus" onClick={this.handlePlus.bind(this)} aria-label="Plus Player">
          +
        </button>
      </div>
    )
  }
}
